/*  ==========================================================================
    OFFER DETAIL
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import {initDynform} from "../../ehotelier/dynforms/init";

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierOfferMinPrice(data);

    // calculate room prices and add it to record
    utils.ehotelierPrices.initEhotelierOfferRoomPrices(data);

    // get desired offer
    let offerDetail,
        offerId = location.pathname.match(/(\d+)\/?$/i)[1];
    $.each(data.records, function(key, record) {
        if(record.id == offerId) {
            offerDetail = record;
        }
    });
    data.offerdetail = offerDetail;

    // replace title-tag in the head area with offer title (and add it also to the breadcrumb)
    let offerTitle;
    $.each(data.offerdetail.offerhotels, function(key, record) {
        offerTitle = record.title;
    });
    $('title').html(offerTitle);
    $('#bn-breadcrumb').find('.bn-breadcrumb__cur').html(offerTitle);

}

// custom function
function funcCustom(container,data) {

    // magnific popup
    utils.mfp.initGallery(container);

    // initialize image slider
    let $sliderContainer = $(container).find('.bn-offer-box__slider'),
        sliderOverrides = {
            nextArrow: vars.slick_nextArrow,
            prevArrow: vars.slick_prevArrow
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    initDynform();
}

// initialization
export function initOfferDetail($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'offer',
        subtype: 'detail'
    };

    // ehotelier service initialization
    utils.ehotelierLoader.initEhotlierService(config);

}



// WEBPACK FOOTER //
// ./source/js/modules/lib/offer-detail.js